import { render } from "./Suggestions.vue?vue&type=template&id=0d50a00e"
import script from "./Suggestions.vue?vue&type=script&lang=js"
export * from "./Suggestions.vue?vue&type=script&lang=js"

import "./Suggestions.vue?vue&type=style&index=0&id=0d50a00e&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__